import { Text } from '@react-pdf/renderer';
import { Nullish } from '@snap-types/types/nullish';

type PartSpecsProps = {
  specs: Nullish<string>;
};

export function PartSpecs({ specs }: PartSpecsProps) {
  if (!specs) {
    return null;
  }

  return <Text style={{ paddingTop: '5px' }}>{specs}</Text>;
}
